/**
 * Created by jimmy on 2020/10/30.
 */
import React from 'react';
import './index.less';
import IMG_New from './images/guider_new.jpg'

const LIST = [ IMG_New ];

const PageModel = props => {
	return (
		<section className="zhujiajiao-guider-container" style={{ minHeight: window.innerHeight }}>
			{
				LIST.map((img, idx) => <img src={img} key={idx} />)
			}
		</section>
	);
};

export default PageModel;
